import { useMemo } from 'react';
import { READ_ONLY } from 'customer-data-objects/property/AccessLevel';
import { isDuration, isReadOnly } from 'customer-data-objects/property/PropertyIdentifier';
import { useIsReadOnlySubscriptionProperty } from './useIsReadOnlySubscriptionProperty';
import { useIsReadOnlyLeadOwnerProperty } from './useIsReadOnlyLeadOwnerProperty';
import { useIsReadOnlyContractProperty } from './useIsReadOnlyContractProperty';
import { useIsReadOnlyPaymentProperty } from './useIsReadOnlyPaymentProperty';
export const useIsPropertyReadOnly = (objectTypeId, property, accessLevel, readOnly) => {
  const isReadOnlySubscriptionProperty = useIsReadOnlySubscriptionProperty(objectTypeId, property);
  const isReadOnlyContractProperty = useIsReadOnlyContractProperty(objectTypeId, property);
  const isReadOnlyLeadOwnerProperty = useIsReadOnlyLeadOwnerProperty(objectTypeId, property);
  const isReadOnlyPaymentProperty = useIsReadOnlyPaymentProperty(objectTypeId, property);
  return useMemo(() => {
    if (accessLevel === READ_ONLY || Boolean(readOnly) || isDuration(property) || isReadOnlySubscriptionProperty || isReadOnlyContractProperty || isReadOnlyLeadOwnerProperty || isReadOnlyPaymentProperty) {
      return true;
    }
    return isReadOnly(property);
  }, [accessLevel, readOnly, isReadOnlySubscriptionProperty, isReadOnlyContractProperty, isReadOnlyLeadOwnerProperty, isReadOnlyPaymentProperty, property]);
};